export default () => {
  class BuilderButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", () => {
        const options = JSON.parse(this.querySelector("[data-options]").textContent);
        const variantSelectsElement = document.querySelector('variant-selects');
        const prepopulateSelectElement = variantSelectsElement.querySelector(`select[name="options[${options.prepopulate_variant}]"]`);
        const selectElements = [...variantSelectsElement.querySelectorAll('select')];
        let builderId = options.builder_id;

        selectElements.every((select) => {
          const selectedOption = select.options[select.selectedIndex];

          if (selectedOption && selectedOption.dataset.builderId) {
            builderId = selectedOption.dataset.builderId;
            return false;
          }

          return true;
        });

        this.parentElement.classList.add('is-loading');

        if (options.prepopulate_variant && prepopulateSelectElement) {
          const optionPosition = prepopulateSelectElement.options[prepopulateSelectElement.selectedIndex].dataset.optionPosition;
          const variantName = prepopulateSelectElement.options[prepopulateSelectElement.selectedIndex].dataset.variantName;
          const prepopulateVariants = options.variants.filter((variant) => variant[`option${optionPosition}`] == variantName);

          localStorage.setItem("builder.prepopulateVariantIds", prepopulateVariants.map(({ id }) => `gid://shopify/ProductVariant/${id}`).join(','));
        }

        localStorage.setItem("builder.customerId", options.customer_id);

        window.location.hash = `#/builder/${builderId}`;
        document.querySelector("builder-index").init();
      });
    }
  }

  const init = () => {
    if (!customElements.get("builder-button")) {
      customElements.define("builder-button", BuilderButton);

      localStorage.removeItem("builder.customerId");
      localStorage.removeItem("builder.pendingSavedCreationId");
      localStorage.removeItem("builder.prepopulateVariantIds");

      window.addEventListener('close-builder', () => {
        document.querySelectorAll('builder-button').forEach((element) => element.parentElement.classList.remove('is-loading'));
      });
    }
  };

  init();
};
